import React, { useEffect, useRef } from "react";

const HUBSPOT_MEETING_URL = "https://meetings-eu1.hubspot.com/haris-samardzic?embed=true";

const MeetingWidget: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Prevent script from being added multiple times
    if (!document.querySelector("script[src*='MeetingsEmbedCode.js']")) {
      const script = document.createElement("script");
      script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="meetings-iframe-container"
      data-src={HUBSPOT_MEETING_URL}
      style={{ minHeight: 600 }}
    />
  );
};

export default MeetingWidget;
